import { getPackageKnowledge } from "../knowledge/knowledgeBase.js";

export interface PackageKnowledge {
  packageName: string;
  category: string;
  notes: string[];
  iosRequirements: string[];
  androidRequirements: string[];
  documentationUrl?: string;
}

/**
 * Searches the registry for knowledge of a package.
 * Delegates entirely to the JSON-backed Knowledge Base.
 */
export function lookupPackageKnowledge(packageName: string): PackageKnowledge | null {
  const kb = getPackageKnowledge(packageName);
  if (!kb) return null;
  return {
    packageName: kb.packageName,
    category: kb.category,
    notes: kb.installHints, // maps installHints to notes for compatibility
    iosRequirements: kb.iosRequirements,
    androidRequirements: kb.androidRequirements,
    documentationUrl: kb.documentationUrl,
  };
}
